import TeamPayments from './TeamPayments';
import Payments from './Payments';

const Billing = () => {
  return process.env.TEAM_BILLING === 'true' ? <Payments /> : <TeamPayments />;
};

export default Billing;
